import React from 'react';
import JSDB from 'fromKotlin/nk';
import {isDocSentToExternalSoftware} from 'utils/externalSoftware';
import DocumentApiSendChip from './DocumentApiSendChip';

type ExternalSoftwareSendChipProps = {
    document: any;
    refresher?: {mutateAsync?: (args: any) => Promise<any>; mutate?: (args: any) => void};
    docType?: number;
};

/** Generic send/resend chip. Named One / Manager / StoreNext / Hashavshevet chips stay as they are. */
const ExternalSoftwareSendChip = ({
    document,
    refresher,
    docType
}: ExternalSoftwareSendChipProps) => {
    const apiConfig = JSDB().apiConfig;
    if (!document || !document.id || !apiConfig?.hasExternalSoftware?.()) return null;
    if (apiConfig.hasOne?.() || apiConfig.hasManager?.() || apiConfig.hasStoreNext?.() || apiConfig.hasHashavshevet?.()) {
        return null;
    }
    return (
        <DocumentApiSendChip
            document={document}
            docType={docType}
            refresher={refresher}
            labelSent='נשלח לתוכנה חיצונית'
            labelNotSent='לא נשלח לתוכנה חיצונית'
            isSent={isDocSentToExternalSoftware}
        />
    );
};

export default ExternalSoftwareSendChip;
